export default "__VITE_ASSET__CsqFpF0j__"